<main class="job-list-page" aria-labelledby="job-list-title">
  <button mat-stroked-button type="button" class="back-button" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>{{ "open_jobs_list_back" | translate }}
  </button>

  <header class="job-list-page__header">
    <h1 id="job-list-title">
      {{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ jobTypeKey | translate }} {{ "open_jobs_list_jobs" | translate }}
    </h1>
  </header>

  <section class="job-list-page__filters" [attr.aria-label]="'open_jobs_list_filters' | translate">
    @if (subSites.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>{{ "open_jobs_list_filter_subsite" | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedSubSite">
          <mat-option value="">{{ "open_jobs_summary_show_all" | translate }}</mat-option>
          @for (subSite of subSites; track subSite) {
            <mat-option [value]="subSite">{{ subSite }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field appearance="outline">
      <mat-label>{{ "open_jobs_list_filter_allocation" | translate }}</mat-label>
      <mat-select [(ngModel)]="allocationType">
        <mat-option value="">{{ "open_jobs_summary_show_all" | translate }}</mat-option>
        <mat-option value="allocated">{{ "open_jobs_list_allocated" | translate }}</mat-option>
        <mat-option value="unallocated">{{ "open_jobs_list_unallocated" | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </section>

  @if (hasLoadError) {
    <div class="job-list-page__state job-list-page__state--error">{{ "open_jobs_list_load_error" | translate }}</div>
  } @else if (hasLoaded && filteredJobs.length === 0) {
    <div class="job-list-page__state">{{ "open_jobs_summary_empty" | translate }}</div>
  } @else if (hasLoaded && isPpm) {
    <section class="ppm-list" [attr.aria-label]="'open_jobs_list_ppm_jobs' | translate">
      @for (job of filteredJobs; track job.id) {
        <article class="ppm-card">
          <div class="ppm-card__primary">
            <h2>{{ "open_jobs_list_ppm_number" | translate: { number: job.referenceNumber } }}</h2>
            <span>{{ job.jobStatusName }}</span>
          </div>
          <dl>
            <div><dt>{{ "open_jobs_list_due_date" | translate }}</dt><dd>{{ job.eta ? (job.eta | date: 'dd/MM/yyyy') : ("open_jobs_summary_not_available" | translate) }}</dd></div>
            @if (job.subSite) { <div><dt>{{ "open_jobs_list_subsite" | translate }}</dt><dd>{{ job.subSite }}</dd></div> }
            <div><dt>{{ "open_jobs_list_fault_service" | translate }}</dt><dd>{{ job.faultServiceName || ("open_jobs_summary_not_available" | translate) }}</dd></div>
            <div><dt>{{ "open_jobs_list_allocated_to" | translate }}</dt><dd>{{ job.allocatedUserEmail || ("open_jobs_list_unassigned" | translate) }}</dd></div>
          </dl>
          @if (job.notes) { <p class="ppm-card__notes">{{ job.notes }}</p> }
          <button mat-stroked-button type="button" (click)="openJob(job)">{{ "open_jobs_list_open_ppm" | translate }}</button>
        </article>
      }
    </section>
  } @else if (hasLoaded) {
    <section class="job-table-wrap" [attr.aria-label]="'open_jobs_list_reactive_jobs' | translate">
      <table class="job-table">
        <thead>
          <tr>
            @if (subSites.length > 0) { <th>{{ "open_jobs_list_subsite" | translate }}</th> }
            <th>{{ "open_jobs_list_job_id" | translate }}</th>
            <th>{{ "open_jobs_list_callout_date" | translate }}</th>
            <th>{{ "open_jobs_list_fault_service" | translate }}</th>
            <th>{{ "open_jobs_list_notes" | translate }}</th>
            <th>{{ "open_jobs_list_allocated_to" | translate }}</th>
            <th>{{ "open_jobs_list_status" | translate }}</th>
            <th><span class="visually-hidden">{{ "open_jobs_list_actions" | translate }}</span></th>
          </tr>
        </thead>
        <tbody>
          @for (job of filteredJobs; track job.id) {
            <tr>
              @if (subSites.length > 0) { <td>{{ job.subSite || ("open_jobs_summary_not_available" | translate) }}</td> }
              <td>{{ job.referenceNumber }}</td>
              <td>{{ job.eta ? (job.eta | date: 'dd/MM/yyyy hh:mm a') : ("open_jobs_summary_not_available" | translate) }}</td>
              <td>{{ job.faultServiceName }}</td>
              <td class="job-notes">{{ job.notes }}</td>
              <td>{{ job.allocatedUserEmail || ("open_jobs_list_unassigned" | translate) }}</td>
              <td>{{ job.jobStatusName }}</td>
              <td class="job-actions">
                <button mat-stroked-button type="button" (click)="openAllocateTo(job)">{{ "open_jobs_list_allocate_to" | translate }}</button>
                <button mat-raised-button type="button" (click)="openJob(job)">{{ "open_jobs_list_open_job" | translate }}</button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>

    <section class="job-cards" [attr.aria-label]="'open_jobs_list_reactive_jobs' | translate">
      @for (job of filteredJobs; track job.id) {
        <article class="job-card">
          <header><strong>{{ job.referenceNumber }}</strong><span>{{ job.jobStatusName }}</span></header>
          @if (job.subSite) { <div><strong>{{ "open_jobs_list_subsite" | translate }}</strong><span>{{ job.subSite }}</span></div> }
          <div><strong>{{ "open_jobs_list_callout_date" | translate }}</strong><span>{{ job.eta ? (job.eta | date: 'dd/MM/yyyy hh:mm a') : ("open_jobs_summary_not_available" | translate) }}</span></div>
          <div><strong>{{ "open_jobs_list_fault_service" | translate }}</strong><span>{{ job.faultServiceName }}</span></div>
          <div><strong>{{ "open_jobs_list_allocated_to" | translate }}</strong><span>{{ job.allocatedUserEmail || ("open_jobs_list_unassigned" | translate) }}</span></div>
          @if (job.notes) { <div><strong>{{ "open_jobs_list_notes" | translate }}</strong><span>{{ job.notes }}</span></div> }
          <div class="job-card__actions">
            <button mat-stroked-button type="button" (click)="openAllocateTo(job)">{{ "open_jobs_list_allocate_to" | translate }}</button>
            <button mat-raised-button type="button" (click)="openJob(job)">{{ "open_jobs_list_open_job" | translate }}</button>
          </div>
        </article>
      }
    </section>
  }

  @if (selectedJob) {
    <div class="allocation-backdrop">
      <section class="allocation-dialog" role="dialog" aria-modal="true" aria-labelledby="allocation-dialog-title">
        <header class="allocation-dialog__header">
          <h2 id="allocation-dialog-title">{{ "open_jobs_list_allocate_to" | translate }}</h2>
          <button mat-icon-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()" [attr.aria-label]="'open_jobs_list_close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </header>

        <form (ngSubmit)="confirmAllocation()">
          <div class="allocation-dialog__body">
            <mat-radio-group name="allocationMode" [(ngModel)]="allocationMode" [disabled]="isAllocating" (change)="changeAllocationMode()" [attr.aria-label]="'open_jobs_list_allocation_type' | translate">
              <mat-radio-button [value]="AllocationMode.INTERNAL">{{ "open_jobs_list_internal" | translate }}</mat-radio-button>
              <mat-radio-button [value]="AllocationMode.EXTERNAL">{{ "open_jobs_list_external" | translate }}</mat-radio-button>
            </mat-radio-group>

            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_email" | translate }}</mat-label>
              <input matInput type="email" name="allocationEmail" [(ngModel)]="allocation.email" maxlength="100" required email [disabled]="isAllocating" placeholder="email@email.com">
            </mat-form-field>

            @if (allocationMode === AllocationMode.EXTERNAL) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_company_name" | translate }}</mat-label>
                <input matInput type="text" name="allocationCompany" [(ngModel)]="allocation.companyName" maxlength="200" required [disabled]="isAllocating" [placeholder]="'open_jobs_list_company_name' | translate">
              </mat-form-field>
            }

            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_technician_name" | translate }}</mat-label>
              <input matInput type="text" name="allocationTechnician" [(ngModel)]="allocation.technicianName" maxlength="200" required [disabled]="isAllocating" [placeholder]="'open_jobs_list_technician_name' | translate">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_phone_number" | translate }}</mat-label>
              <input matInput type="tel" name="allocationPhone" [(ngModel)]="allocation.phoneNumber" maxlength="30" required [disabled]="isAllocating" [placeholder]="'open_jobs_list_phone_number' | translate">
            </mat-form-field>

            @if (allocationErrorKey) {
              <p class="allocation-dialog__error" role="alert">{{ allocationErrorKey | translate }}</p>
            }
          </div>

          <footer class="allocation-dialog__footer">
            <button mat-stroked-button type="button" [disabled]="isAllocating" (click)="closeAllocateTo()">{{ "open_jobs_list_cancel" | translate }}</button>
            <button mat-raised-button type="submit" [disabled]="!canConfirmAllocation || isAllocating">{{ "open_jobs_list_confirm_allocation" | translate }}</button>
          </footer>
        </form>
      </section>
    </div>
  }
</main>